import { cx } from '@linaria/core';
import { breakpoints } from '@ui/css';
import { ShowFor, HideFor } from '@utils/react';
import { MobileSearch } from '../../../atoms/search.mobile.js';
import { heading, header } from '../../shared.header.style.js';
import { Filters } from '../molecules/filters/filters.js';
import { componentEntryStore } from '../state.js';
import { StudentTablist } from './molecule.tablist.js';
import { mobileActions, header as header$1, filters } from './root.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { MobileFilters } from '../molecules/filters/filters.mobile.js';

function StudentEntriesView(props) {
  return /*#__PURE__*/jsxs("section", {
    ref: props.ref,
    children: [/*#__PURE__*/jsxs("header", {
      className: cx(header, header$1),
      children: [/*#__PURE__*/jsx("h1", {
        className: heading,
        children: "Besvarelser"
      }), /*#__PURE__*/jsxs(ShowFor, {
        className: mobileActions,
        breakpoint: breakpoints.mobile,
        children: [/*#__PURE__*/jsx(MobileSearch, {
          label: "S\xF8g i besvarelser",
          onQueryChange: newQuery => componentEntryStore.dispatch(componentEntryStore.actions.setQuery(newQuery))
        }), /*#__PURE__*/jsx(MobileFilters, {
          withTimespan: true,
          withProducts: true
        })]
      })]
    }), /*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx(Filters, {
        className: filters,
        withTimespan: true,
        withProducts: true
      })
    }), /*#__PURE__*/jsx(StudentTablist, {})]
  });
}

export { StudentEntriesView };
//# sourceMappingURL=root.js.map
